import {ChangeDetectionStrategy, Component} from '@angular/core';
import {
  LotteriesDialogContentComponent,
  LotteryDialogListItemDirective
} from "../lotteries-dialog-content/lotteries-dialog-content.component";
import {LotteryListItemComponent} from "../../../../components/lottery-list-item/lottery-list-item.component";
import {NotificationPage} from "../../multi-page-notification/multi-page-notification.component";
import {SelectedNotificationDto} from "homey-housing-lottery-app-dto";

@Component({
  selector: 'homey-selected-applications-dialog-content',
  imports: [
    LotteriesDialogContentComponent,
    LotteryDialogListItemDirective,
    LotteryListItemComponent
  ],
  templateUrl: './selected-applications-dialog-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectedApplicationsDialogContentComponent extends NotificationPage<SelectedNotificationDto> {
}
